import { useEffect } from "react";
import RequestLoginForm from "../../components/Auth/RequestLoginForm";

export default function RequestLoginPage() {
	useEffect(() => {
		// Fetch any data
	}, []);

	useEffect(() => {
		// Send any analytics
	}, []);

	return (
		<RequestLoginForm />
	)
}
